import AvailabilityOptionStatus from '@jbhi-fi/lanyard-ui/components/AvailabilityOptionStatus';
import React from 'react';
import { getTitleCase } from '@jbhi-fi/utils/src/getTitleCase/getTitleCase';
import { StoreAvailabilityDetails, StoreAvailabilityOption } from '../utils/types';
import { styles } from './StoreAvailabilityResults.css';
import { SelectStoreButton } from '../../localisation/components/store-results/SelectStoreButton/SelectStoreButton';
import { useLocalisationContext } from '../../localisation/context/LocalisationContext';
import { DisplayModelOptionStatus } from '../../localisation/components/product-fulfilment-info/PickupInStoreContainer/DisplayModelOptionStatus/DisplayModelOptionStatus';
import { getAvailabilityText } from '../utils/availabilityUtils';

const EXCLUSIONS = ['JB', 'HOME', 'DFO'];

export type StoreAvailabilityResultsProps = {
  storeAvailabilityResults: Array<StoreAvailabilityDetails>;
  isPreOrder?: boolean;
  isHideInstoreFamily?: boolean;
  onClose: () => void;
  updateMySelectedStoreFromId: (storeId: number, gtmString?: string) => void;
  onStoreClick?: (storeId: number) => void;
};

const StoreAvailabilityResults = ({
  storeAvailabilityResults,
  isPreOrder,
  isHideInstoreFamily,
  onClose,
  updateMySelectedStoreFromId,
  onStoreClick,
}: StoreAvailabilityResultsProps) => {
  const { shouldUsePdpHybridPickupSlider } = useLocalisationContext();
  const handleClick = async (storeId: number) => {
    onClose();
    await updateMySelectedStoreFromId(storeId, 'hybrid-availability-store-select');
  };
  const isDisplayOnly = (option: StoreAvailabilityOption) => option.name === 'Display Only';
  const isClickAndCollectAvailable = (option: StoreAvailabilityOption) => option.name === 'Click & Collect';
  const testidPrefix = 'store-availability-';
  const isCartPage = window.location.pathname === '/cart';
  return (
    <div data-testid={`${testidPrefix}results`}>
      {storeAvailabilityResults
        ? storeAvailabilityResults.map(store => {
            return (
              <div className={styles.storeContainer} data-testid={`${testidPrefix}result`} key={store.name}>
                <div className={styles.storeHeader} data-testid={`${testidPrefix}result-header`}>
                  <div
                    className={styles.storeTitle}
                    data-testid={`${testidPrefix}result-title`}
                    onClick={() => onStoreClick && onStoreClick(store.id)}
                  >
                    {getTitleCase(store.name, EXCLUSIONS)}
                  </div>
                  <div className={styles.storeDistance} data-testid={`${testidPrefix}result-distance`}>
                    {store.distance?.toFixed(1)}km
                  </div>
                </div>
                <div className={styles.storeDetails} data-testid={`${testidPrefix}result-details`}>
                  <div className={styles.openingHours} data-testid={`${testidPrefix}result-opening-hours`}>
                    {store.closingTime}
                  </div>
                </div>
                <div
                  className={
                    shouldUsePdpHybridPickupSlider
                      ? styles.availabilityOptionsContainerHybrid
                      : styles.availabilityOptionsContainer
                  }
                  data-testid={`${testidPrefix}result-options-container`}
                >
                  {store.options.find(isDisplayOnly) ? (
                    <DisplayModelOptionStatus key={0} />
                  ) : (
                    <div className={styles.availabilityOptionStatusBlock({ isCartPage })}>
                      <div className={styles.availabilityOptionStatusContainer}>
                        {store.options.map((option, i) => {
                          if (option.name === 'In-store' && isHideInstoreFamily && !option.isAvailable) {
                            return null;
                          }
                          return !isPreOrder || option.name === 'Click & Collect' ? (
                            <AvailabilityOptionStatus
                              classes={styles.storeOption}
                              key={`${option.name}-${i}`}
                              name={
                                option.isAvailable
                                  ? getAvailabilityText(option.name, store.isStoreOpenInNexthour, store.isAwaitingStock)
                                  : option.name
                              }
                              isAvailable={option.isAvailable}
                            />
                          ) : null;
                        })}
                      </div>
                      {store.options.find(isClickAndCollectAvailable)?.isAvailable &&
                      store.importantMessaging &&
                      (isPreOrder || store.isAwaitingStock) ? (
                        <p className={styles.importantMessaging}>{store.importantMessaging}</p>
                      ) : null}
                    </div>
                  )}
                </div>
                {shouldUsePdpHybridPickupSlider ? (
                  <SelectStoreButton handleClick={() => handleClick(store.id)} variant="hybrid" />
                ) : null}
              </div>
            );
          })
        : null}
    </div>
  );
};

export default StoreAvailabilityResults;
